module.exports = __webpack_public_path__ + "static/media/i35.edebee87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i35.svg
// module id = 402
// module chunks = 12